<script>
  // import windowOpenPdf from "@utils/window-open-pdf";
  import createDownloadLink from "@utils/create-download-link";
  // import PDFObject from "pdfobject"

  export default {
    props: {
      item: {
        type: Object,
        required: true
      },
      icon: {
        type: String,
        default: '<i class="icomoon icon-document icon__document"></i>'
      },
      isSiteUpload: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'open',
        validator(value) {
          return [
            'open',
            'download'
          ].includes(value)
        },
      }
    },
    data() {
      return {
        filedoading:false,
      }
    },
    methods: {
      async handleClickItem(file) {
        this.filedoading = true;
        const response = await this.$store.dispatch('global/fetchFile', {
          url: file.downloadLink,
          responseType: 'blob'
        });

          createDownloadLink(file.title||file.name, response)
        
        this.filedoading = false
      }
    }
  }
</script>
<template>
  <BaseButton
    v-if="isSiteUpload"
    :href="item.file"
    :class="$style.fileLoad"
    class="isStylePrimary isOutline isFull"
    style="border: 2px solid #F5F5F5"
    target="_blank"
  >
    <div class="d-flex">
      <div class="fileLoad__icon align-self-center" v-html="icon">
      </div>
      <span class="ml-2 fileLoad__title font-medium ">{{ item.title || item.name}}</span>
    </div>
  </BaseButton>
  <BaseButton
    v-else
    v-loading="filedoading"
    :class="$style.fileLoad"
    class="isStylePrimary isOutline isFull"
    style="border: 2px solid #F5F5F5"
    @click="handleClickItem(item)"
  >
    <div class="d-flex">
      <div class="fileLoad__icon align-self-center" v-html="icon">
      </div>
      <span class="ml-2 fileLoad__title font-medium ">{{ item.title || item.name}}</span>
    </div>
  </BaseButton>
</template>
<style lang="scss" module>
  .fileLoad {
    // height: 55px;
    padding: 0 18px;
    color: $color-primary;
    text-decoration: none;
    background: #FFF;
    // border: 2px solid rgba(226, 228, 232, 1);
    border-radius: 5px;
    transition: .3s;
    white-space: unset;
    text-align: left;
    line-height: 1.8;
    padding: 12px 18px;
    height: 100%;
    &:hover:not(:disabled) {
      color: #FFF;
      text-decoration: none;
      // border-color: $color-primary-hover;
    }

    :global {
      .fileLoad {
        &__icon {
          // font-size: 28px;
          i {

          }

          .icon {
            &-document {
              display: block;
              margin-bottom: 3px;
              font-size: 1.25em;
            }

            &-download {
              font-size: 0.875em;
              vertical-align: middle;
            }
          }
        }

        &__title {
          font-size: 1rem;
          // transition: .3s;
          align-self: center;
        }
      }
      .el-loading-spinner {
        margin-top: -27px;
      }
    }
  }
</style>
